import {SvgIcon} from '@mui/material';

export default function ArrowDownSelectIcon() {
	return (
		<SvgIcon className="mx-4" width="24" height="24" viewBox="0 0 24 24" fill="none">
			<mask id="mask0_1355_5190" style={{maskType: 'alpha'}} maskUnits="userSpaceOnUse" x="0" y="0" width="24"
			      height="24">
				<rect width="24" height="24" fill="#D9D9D9"/>
			</mask>
			<g mask="url(#mask0_1355_5190)">
				<path
					d="M11.9999 14.65C11.8832 14.65 11.7709 14.6333 11.6629 14.6C11.5542 14.5666 11.4582 14.5 11.3749 14.4L6.8499 9.89996C6.71657 9.74996 6.6499 9.57496 6.6499 9.37496C6.6499 9.17496 6.7249 8.99996 6.8749 8.84996C7.0249 8.71663 7.1999 8.64996 7.3999 8.64996C7.5999 8.64996 7.7749 8.71663 7.9249 8.84996L11.9999 12.925L16.0999 8.84996C16.2332 8.69996 16.3999 8.62896 16.5999 8.63696C16.7999 8.64563 16.9749 8.71663 17.1249 8.84996C17.2749 8.99996 17.3499 9.17896 17.3499 9.38696C17.3499 9.59563 17.2749 9.76663 17.1249 9.89996L12.6249 14.4C12.5416 14.5 12.4459 14.5666 12.3379 14.6C12.2292 14.6333 12.1166 14.65 11.9999 14.65Z"
					fill="#29006B"/>
			</g>
		</SvgIcon>
	);
}
